import { ActionsData } from "../../types/interface";


export const actionsList: Array<ActionsData> = [
    {
        uuid: 'e27asad27cfd',
        title: 'Missed Intros',
        assets: [
            {
                title: 'New Hire Training - Refresher',
                description: '',
                link: 'https://ssense-regalix.nytro.ai/section-assets/ssense-x-regalix-nh-training-and-onboarding-ojt',
                selected: false,
            },
            {
                title: 'CSAT Champions Call #1',
                description: '',
                link: 'https://firebasestorage.googleapis.com/v0/b/nytro-ssense-storage.appspot.com/o/actions%2Fassets%2FassetOne.mp3?alt=media&token=06de0e30-638d-4002-8b77-902b29b289b7',
                selected: false,
            },
            {
                title: 'CSAT Champions Call #2',
                description: '',
                link: 'https://firebasestorage.googleapis.com/v0/b/nytro-ssense-storage.appspot.com/o/actions%2Fassets%2FassetTwo.mp3?alt=media&token=c21ac546-d227-4a91-a43e-375566584c36',
                selected: false,
            },
            {
                title: 'Language Best Practices',
                description: '',
                link: 'https://www.youtube.com/watch?v=Vn9EHuNFkRo',
                selected: false,
            },
            {
                title: 'Sample Practice Script',
                description: '',
                link: 'https://www.google.com/',
                selected: false,
            }
        ]
    },
    {
        uuid: 'e27ad27cfd',
        title: 'Missed Salutations',
        assets: [
            {
                title: 'New Hire Training - Refresher',
                description: '',
                link: 'https://ssense-regalix.nytro.ai/section-assets/ssense-x-regalix-nh-training-and-onboarding-ojt',
                selected: false,
            },
            {
                title: 'CSAT Champions Call #1',
                description: '',
                link: 'https://firebasestorage.googleapis.com/v0/b/nytro-ssense-storage.appspot.com/o/actions%2Fassets%2FassetOne.mp3?alt=media&token=06de0e30-638d-4002-8b77-902b29b289b7',
                selected: false,
            },
            {
                title: 'CSAT Champions Call #2',
                description: '',
                link: 'https://firebasestorage.googleapis.com/v0/b/nytro-ssense-storage.appspot.com/o/actions%2Fassets%2FassetTwo.mp3?alt=media&token=c21ac546-d227-4a91-a43e-375566584c36',
                selected: false,
            },
            {
                title: 'Language Best Practices',
                description: '',
                link: 'https://www.youtube.com/watch?v=Vn9EHuNFkRo',
                selected: false,
            },
            {
                title: 'Sample Practice Script',
                description: '',
                link: 'https://www.google.com/',
                selected: false,
            }
        ]
    },
    {
        uuid: 'e27ad27cfdk',
        title: 'Dead Air',
        assets: [
            {
                title: 'New Hire Training - Refresher',
                description: '',
                link: 'https://ssense-regalix.nytro.ai/section-assets/ssense-x-regalix-nh-training-and-onboarding-ojt',
                selected: false,
            },
            {
                title: 'CSAT Champions Call #1',
                description: '',
                link: 'https://firebasestorage.googleapis.com/v0/b/nytro-ssense-storage.appspot.com/o/actions%2Fassets%2FassetOne.mp3?alt=media&token=06de0e30-638d-4002-8b77-902b29b289b7',
                selected: false,
            },
            {
                title: 'CSAT Champions Call #2',
                description: '',
                link: 'https://firebasestorage.googleapis.com/v0/b/nytro-ssense-storage.appspot.com/o/actions%2Fassets%2FassetTwo.mp3?alt=media&token=c21ac546-d227-4a91-a43e-375566584c36',
                selected: false,
            },
            {
                title: 'Language Best Practices',
                description: '',
                link: 'https://www.youtube.com/watch?v=Vn9EHuNFkRo',
                selected: false,
            },
            {
                title: 'Sample Practice Script',
                description: '',
                link: 'https://www.google.com/',
                selected: false,
            }
        ]
    },
    {
        uuid: 'e27ad27cfdp',
        title: 'Hold Etiquette',
        assets: [
            {
                title: 'New Hire Training - Refresher',
                description: '',
                link: 'https://ssense-regalix.nytro.ai/section-assets/ssense-x-regalix-nh-training-and-onboarding-ojt',
                selected: false,
            },
            {
                title: 'CSAT Champions Call #1',
                description: '',
                link: 'https://firebasestorage.googleapis.com/v0/b/nytro-ssense-storage.appspot.com/o/actions%2Fassets%2FassetOne.mp3?alt=media&token=06de0e30-638d-4002-8b77-902b29b289b7',
                selected: false,
            },
            {
                title: 'CSAT Champions Call #2',
                description: '',
                link: 'https://firebasestorage.googleapis.com/v0/b/nytro-ssense-storage.appspot.com/o/actions%2Fassets%2FassetTwo.mp3?alt=media&token=c21ac546-d227-4a91-a43e-375566584c36',
                selected: false,
            },
            {
                title: 'Language Best Practices',
                description: '',
                link: 'https://www.youtube.com/watch?v=Vn9EHuNFkRo',
                selected: false,
            },
            {
                title: 'Sample Practice Script',
                description: '',
                link: 'https://www.google.com/',
                selected: false,
            }
        ]
    },
    {
        uuid: 'e27ad27cfdo',
        title: 'Tone/Empathy',
        assets: [
            {
                title: 'New Hire Training - Refresher',
                description: '',
                link: 'https://ssense-regalix.nytro.ai/section-assets/ssense-x-regalix-nh-training-and-onboarding-ojt',
                selected: false,
            },
            {
                title: 'CSAT Champions Call #1',
                description: '',
                link: 'https://firebasestorage.googleapis.com/v0/b/nytro-ssense-storage.appspot.com/o/actions%2Fassets%2FassetOne.mp3?alt=media&token=06de0e30-638d-4002-8b77-902b29b289b7',
                selected: false,
            },
            {
                title: 'CSAT Champions Call #2',
                description: '',
                link: 'https://firebasestorage.googleapis.com/v0/b/nytro-ssense-storage.appspot.com/o/actions%2Fassets%2FassetTwo.mp3?alt=media&token=c21ac546-d227-4a91-a43e-375566584c36',
                selected: false,
            },
            {
                title: 'Language Best Practices',
                description: '',
                link: 'https://www.youtube.com/watch?v=Vn9EHuNFkRo',
                selected: false,
            },
            {
                title: 'Sample Practice Script',
                description: '',
                link: 'https://www.google.com/',
                selected: false,
            }
        ]
    }
]